<!--
  web/cate-index?cateId=553
-->

<template>
  <div v-wechat-title="cateName" class="cate-index-page">
    <van-tabs ref="tabs" v-model="active" swipeable @change="cateChange">
      <van-tab v-for="cate of topCateList" :key="cate.cateId" :name="cate.cateId" :title="cate.name">
        <search :data="searchKey" @search="onSearch" />

        <div class="ads">
          <van-image v-if="adsImage" :src="adsImage" height="150" lazy-load radius="5" />
        </div>

        <div class="goods-list">
          <MallSortTable :cate-id="cateId" />
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { api_get_cate_by_id, api_get_goods_cate_list } from "@/api/goods-api";
import Vue from "vue";
import { Lazyload } from "vant";
import MallSortTable from "@/components/common/MallSortTable";
import { getCateIsBan } from "@/api/user";

import request from "@/util/axios";

Vue.use(Lazyload);

export default {
  name: "cate-index",
  components: { MallSortTable },

  data() {
    return {
      searchKey: '',
      keyword: '',
      cateId: 0,
      cateName: '',
      adsImage: '',
      subCateList: [],
      pageCount: 0,
      active: 0,
      topCateList: []
    }
  },

  watch: {
    topCateList(v1, v2) {
      budo_log.info('#60 watch topCateList', v1, v2)
      this.active = this.cateId;
    }
  },

  created() {
    this.cateId = Number(this.$route.query.cateId);
    this.active = this.cateId;
    budo_log.info('#69 cate-index created, active=' + this.active, "store=", this.$store)

    // 当前分类的顶级分类的下级分类
    request.post_form("/mall/wx/Goods/list-top-goods-cate", {
      cateId: this.cateId
    }).then(res => {
      console.log("#72 list-top-goods-cate", res)

      this.topCateList = res.data.filter(f => f.topicId === 0);
      budo_log.debug('#74 topCateList', this.topCateList)

      // 特殊处理
      if (this.cateId === 11) {
        getCateIsBan(11).then(cateRes => {
          if (cateRes.data) {
            this.topCateList.unshift(cateRes.data);
            this.$refs.tabs.scrollTo(this.cateId);
          }
        })
      }
    })

    this.dataList();
  },

  methods: {
    onSearch(value) {
      this.$emit('searchKey', value);

      this.$router.push({
        path: "goods-list",
        query: {
          searchType: 1,
          cateId: this.cateId,
          value,
        },
      });
    },

    cateChange(name, title) {
      this.cateId = name;
      this.dataList();
    },

    dataList() {
      api_get_cate_by_id(this.cateId).then(res => {
        this.adsImage = res.data.adsImage;
        this.cateName = res.data.name;

        api_get_goods_cate_list(this.cateId).then(sub => {
          this.subCateList = sub.data;
          this.pageCount = this.subCateList.length % 12 === 0 ? (this.subCateList.length / 12) : parseInt(this.subCateList.length / 12, 10) + 1
          budo_log.info("#115 pageCount=", this.pageCount)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.cate-index-page {
  min-height: 100vh;
  background-color: #E5E5E5;

  .ads {
    padding: 0 15px;
    margin-top: 10px;
  }

  .cate-list {
    padding: 5px;
    border-radius: 5px;
    margin: 10px 15px;
    background-color: #FFFFFF;
  }

  .goods-list {
    margin-top: 20px;
  }
}
</style>
